import { ResourceFieldDataFragment } from 'generated/resources/graphql'

// TODO: use GraphQL enum when entity is updated
type UsageGroupEnum =
  | 'employees-questions'
  | 'employee-profile'
  | 'basic-information'
  | 'identification-number'
  | 'general-information'

export const filterCustomResourceFieldsDataByUsageGroup = (
  customResourceFieldsData: ResourceFieldDataFragment[],
  usageGroup: UsageGroupEnum
) => {
  return customResourceFieldsData.filter(
    (customResourceField) => customResourceField.field?.usageGroup.slug === usageGroup
  )
}
